export default __webpack_public_path__ + "static/media/target.667d05eb.webp";